var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisibilityOn = function SvgVisibilityOn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,8.9c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1C15.1,10.3,13.7,8.9,12,8.9z  M12,13.9c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9C13.9,13,13,13.9,12,13.9z",
    fill: "#8F95AB"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,4.9c-4.3,0-8.1,2.9-9.2,7c0,0.1,0,0.2,0,0.3c1.2,4.1,5,7,9.2,7s8.1-2.9,9.2-7c0-0.1,0-0.2,0-0.3 C20.1,7.7,16.3,4.9,12,4.9z M12,17.9c-3.6,0-6.9-2.4-8-5.9c1.1-3.5,4.3-5.9,8-5.9c3.6,0,6.9,2.4,8,5.9C18.9,15.5,15.6,17.9,12,17.9 z",
    fill: "#8F95AB"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisibilityOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/VisibilityOn.e5148c53.svg";